import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
})
export class DocumentViewerComponent implements OnInit {

  @Input() public file: any;
  constructor(
    public authService: AuthService,
    public modalCtrl: ModalController,
    ) { }

  ngOnInit() {

  }

  backBtn() {
    this.modalCtrl.dismiss(true, 'viewed');
  }


}
